import { ConsentOptions } from "../core/types";
import { SafeStorage } from "../storage/storage";
import { CookieOptions } from "../storage/cookie";

export class ConsentManager {
  private static CONSENT_KEY = "__thrico_consent";
  private consentState: ConsentOptions;
  private consentRequired: boolean;
  private cookieOptions: CookieOptions;
  private onChangeListeners: Array<(consent: ConsentOptions) => void> = [];

  constructor(
    defaultConsent?: Partial<ConsentOptions>,
    consentRequired: boolean = false,
    cookieOptions: CookieOptions = {},
  ) {
    this.consentRequired = consentRequired;
    this.cookieOptions = cookieOptions;

    // Load from storage or default
    const saved = SafeStorage.getItem(ConsentManager.CONSENT_KEY);
    if (saved) {
      try {
        this.consentState = JSON.parse(saved);
      } catch {
        this.consentState = this.getDefaults(defaultConsent);
      }
    } else {
      this.consentState = this.getDefaults(defaultConsent);
    }
  }

  private getDefaults(custom?: Partial<ConsentOptions>): ConsentOptions {
    return {
      analytics: custom?.analytics !== undefined ? custom.analytics : !this.consentRequired,
      marketing: custom?.marketing !== undefined ? custom.marketing : false,
      personalization: custom?.personalization !== undefined ? custom.personalization : !this.consentRequired,
    };
  }

  public getConsent(): ConsentOptions {
    return { ...this.consentState };
  }

  public setConsent(newConsent: Partial<ConsentOptions>): void {
    this.consentState = {
      ...this.consentState,
      ...newConsent,
    };

    SafeStorage.setItem(
      ConsentManager.CONSENT_KEY,
      JSON.stringify(this.consentState),
      this.cookieOptions,
    );

    for (const listener of this.onChangeListeners) {
      try {
        listener(this.consentState);
      } catch {}
    }
  }

  public isCategoryAllowed(category: keyof ConsentOptions): boolean {
    if (!this.consentRequired) return true;
    return !!this.consentState[category];
  }

  public onConsentChange(listener: (consent: ConsentOptions) => void): void {
    this.onChangeListeners.push(listener);
  }
}
